import * as React from 'react';
import './Required.scss';
import { RequiredInterface } from './RequiredInterface';

const defaultRequiredIndicator = '*';

export function formatRequiredIndicator(props: RequiredInterface): JSX.Element {
  let required: JSX.Element = null;
  if (props.required) {
    const requiredIndicator = props.requiredIndicator ? props.requiredIndicator : defaultRequiredIndicator;
    required = (
      <span className="requiredIndicator"> {requiredIndicator}</span>
    );
  }
  return required;
}
